import { useI18n } from '../i18n/i18n.jsx';
import Container from '../components/UI/Container';
import Section from '../components/UI/Section';
import SectionTitle from '../components/UI/SectionTitle';
import TeamCard from '../components/TeamCard/TeamCard';
import myratImage from '../styles/assets/our team/image1.png';
import merdanImage from '../styles/assets/our team/image2.png';
import ilamanImage from '../styles/assets/our team/image.png';

const Team = () => {
  const { t } = useI18n();

  // Team member keys for translations
  const teamMemberKeys = [
    { key: 'ilaman', image: ilamanImage },
    { key: 'myrat', image: myratImage },
    { key: 'merdan', image: merdanImage },
    { key: 'saparmyrat', image: '' },
    { key: 'kerim', image: '' },
    { key: 'gulbahar', image: '' }
  ];

  return (
    <main>
      {/* Hero Section */}
      <Section className="pt-24 sm:pt-32 pb-16 bg-neutral-light dark:bg-neutral-900/50">
        <Container>
          <div className="max-w-4xl mx-auto text-center animate-fade-in">
            <div className="w-16 h-1 bg-accent mx-auto mb-6 rounded-full" />
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-primary dark:text-white mb-4">
              {t('team.title')}
            </h1>
            <p className="text-xl text-neutral-600 dark:text-neutral-300 leading-relaxed">
              {t('team.subtitle')}
            </p>
          </div>
        </Container>
      </Section>

      {/* Team Grid Section */}
      <Section>
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMemberKeys.map((member, index) => (
              <div
                key={member.key}
                className="animate-slide-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <TeamCard
                  name={t(`team.members.${member.key}.name`)}
                  title={t(`team.members.${member.key}.title`)}
                  description={t(`team.members.${member.key}.description`)}
                  image={member.image}
                />
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* CTA Section */}
      <Section className="bg-primary text-white pb-24 md:pb-16">
        <Container>
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-serif font-semibold mb-4">
              {t('team.cta.title')}
            </h2>
            <p className="text-xl mb-8 text-blue-100">
              {t('team.cta.subtitle')}
            </p>
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-white text-primary font-medium rounded-lg hover:bg-neutral-100 transition-colors duration-200 shadow-lg"
            >
              {t('team.cta.button')}
            </a>
          </div>
        </Container>
      </Section>
      {/* Bottom padding for mobile nav */}
      <div className="pb-24 md:pb-0"></div>
    </main>
  );
};

export default Team;
